import { setupChatbotEvent } from "@src/analytics/chatbot";
import { generateRecordId } from "@src/analytics/helpers";
import { IContext } from "@src/context";
import { getInitialAccessUrl } from "@src/utils/initialAccessUrl";
import "./index.css";
import singleUrlHelper from "@src/utils/url";

export const CHATBOT_ROOT_ID = "chatbot-root";

export function clearChatbot(isChatbotEnable: boolean) {
  const chatbotRoot = document.getElementById(CHATBOT_ROOT_ID);
  if (!chatbotRoot || isChatbotEnable) return;
  chatbotRoot.style.display = "none";
}

export function setupChatbot(context: IContext) {
  const chatbotRoot = document.getElementById(CHATBOT_ROOT_ID);

  const isParkingPage = singleUrlHelper.parkingTopUrlList.some((url) =>
    window.location.pathname.startsWith(url)
  );
  if (chatbotRoot == null || isParkingPage) {
    return;
  }

  const contentWidth = window.innerWidth;
  if (contentWidth <= 430) {
    const container = chatbotRoot.closest(".container-contact-bottom-wrap");
    const xxs = contentWidth < 390;
    if (container instanceof HTMLElement && container.children.length > 3) {
      container.style.paddingLeft = xxs ? "4px" : "12px";
      container.style.justifyContent = "left";
    }
  }

  setupChatbotNavigation();
  setupChatbotEvent();

  Promise.all([
    import("react-dom/client"),
    import("chatbot-widget"),
    import("chatbot-widget/styles"),
  ]).then(([{ createRoot }, { ChatbotWidget }]) => {
    const root = createRoot(chatbotRoot);

    const clientId = "vh-web-chatbot";
    const apiURL = "https://d27s888xaittyq.cloudfront.net";

    root.render(
      <ChatbotWidget
        clientId={clientId}
        apiURL={apiURL}
        url={window.location.href}
        initialAccessUrl={getInitialAccessUrl() || window.location.href}
        recordId={generateRecordId()}
        UID={generateRecordId()}
        locale={context.locale}
      />
    );
  });
}

function setupChatbotNavigation() {
  const handleNavigate = (e: CustomEvent<string>) => {
    // Set flag to skip beforeunload prevention for this navigation
    // This prevents the "leave site?" popup from appearing
    window.sessionStorage.setItem("vh-navigation-in-progress", "true");

    try {
      const url = new URL(e.detail);
      // Include pathname, search params, and hash (anchor) to preserve full URL
      window.location.href = url.pathname + url.search + url.hash;
    } catch {
      window.location.href = e.detail;
    }
  };
  window.addEventListener(
    "vh-navigate-same-tab",
    handleNavigate as EventListener
  );
}
